import axios from 'more-request/instance';
// import axios from 'axios';
import request from '../request';

// const urlPrexProduct = ''
const urlPrexProduct = '/product';
const urlPrexUser = '/user-center';
const baseUrl = request.getBaseUrl();
const server = {
  // 获取 审核数据
  queryAgreementAuditRecord(params) {
    return request.fetch(`${urlPrexProduct}/shareAgreement/auditRecord`, params);
  },
  // 2-通过供应商Id查询有效分类树：产品目录+共享分类
  queryShareAgreementCategoryTree(params) {
    return request.post('/product/shareAgreement/queryShareAgreementCategoryTree', params);
  },
  getAgreementList(params) {
    return request.post(`${urlPrexProduct}/agreement/queryAgreementByPage`, params);
  },
  getAgreementListForSupplier(params) {
    return request.post(`${urlPrexProduct}/agreement/queryAgreementForSupplierByPage`, params);
  },
  getAgreementListForPurchase(params) {
    return request.post(`${urlPrexProduct}/agreement/queryAgreementForPurchaseByPage`, params);
  },
  getMemberList(params) {
    return request.post(`${urlPrexProduct}/agreement/queryMemberByPage`, params);
  },
  getProductList(params) {
    return request.post(`${urlPrexProduct}/agreement/queryPriceByPage`, params);
  },
  queryFirstPartyList(params) {
    return request.post(`${urlPrexUser}/company/queryPurchasers`, params);
  },
  querySupplierList(params) {
    return request.post(`${urlPrexUser}/company/querySupplier`, params);
  },
  queryPurchasersList(params) {
    return request.post(`${urlPrexUser}/company/queryPurchasersNoDelete`, params);
  },
  queryCompanyInfoList(params) {
    return request.post(`${urlPrexUser}/company/batchQuery`, params);
  },
  addAgreement(params) {
    return request.post(`${urlPrexProduct}/agreement/addAgreement`, params);
  },
  uploadFiles() {
    return `${axios.defaults.baseURL}/product/fileUploadForAgreementFile`;
  },
  getAgreementDetail(params) {
    return request.fetch(`${urlPrexProduct}/agreement/queryAgreementInfoById`, params);
  },
  editAgreement(params) {
    return request.post(`${urlPrexProduct}/agreement/editAgreementEdit`, params);
  },
  // 修改盐湖得框架协议
  editAgreementForSL(params) {
    return request.post(`${urlPrexProduct}/agreement/editAgreementForSL`, params);
  },

  deleteAgreement(params) {
    return request.fetch(`${urlPrexProduct}/agreement/agreementDelete`, params);
  },
  stopAgreement(params) {
    return request.fetch(`${urlPrexProduct}/agreement/agreementDisable`, params);
  },
  startAgreement(params) {
    return request.fetch(`${urlPrexProduct}/agreement/agreementEnabled`, params);
  },
  getProductPriceList(params) {
    return request.post(`${urlPrexProduct}/agreement/queryPriceByPage`, params);
  },
  getEpecProductPriceList(params) {
    return request.post(`${urlPrexProduct}/agreement/queryEpecPriceByPage`, params);
  },
  agreementPricePurchasers4Confirm(params) {
    return request.post(`${urlPrexProduct}/agreement/agreementPricePurchasers4Confirm`, params);
  },
  agreementPricePurchaser4Refuse(params) {
    return request.post(`${urlPrexProduct}/agreement/agreementPricePurchaser4Refuse`, params);
  },
  getAddProductList(params) {
    return request.post(`${urlPrexProduct}/skuManagement/querySkuByPage`, params);
  },
  addAgreementPrice(params) {
    return request.post(`${urlPrexProduct}/agreement/addAgreementPriceEdit`, params);
  },
  updateAgreementPrice(params) {
    return request.post(`${urlPrexProduct}/agreement/agreementPriceSupplier4edit`, params);
  },
  updateAgreementPriceByAdd(params) {
    return request.post(`${urlPrexProduct}/agreement/agreementPriceSupplierAdd`, params);
  },
  deleteAgreementPrice(params) {
    return request.fetch(`${urlPrexProduct}/agreement/deleteAgreementPriceEdit`, params);
  },
  supplierSubmitConfirm(params) {
    return request.fetch(`${urlPrexProduct}/agreement/agreementPriceSupplierSubmit`, params);
  },
  getPartACompanyList(params) {
    return request.post(`${urlPrexUser}/companyRelation/querySonCompany`, params);
  },
  // 新增物料类别
  addMdmType(params) {
    return request.post(`${urlPrexProduct}/category/selectCategoryByParentId`, params, {
      preventRepeat: false,
    });
  },
  // 查询物料类别列表分页
  queryMdmTypeList(params) {
    return request.fetch(`${urlPrexProduct}/agreement/queryAgreementCategoryByPage`, params);
  },
  // 查询物料类别列表不分页
  getMdmTypeList(params) {
    return request.fetch(`${urlPrexProduct}/agreement/queryAgreementCategoryById`, params);
  },
  // 框架协议停用
  stopAgreementPrice(params) {
    return request.post(`${urlPrexProduct}/agreement/agreementPriceDisable`, params);
  },
  // 框架协议启用
  startAgreementPrice(params) {
    return request.post(`${urlPrexProduct}/agreement/agreementPriceEnabled`, params);
  },
  // 获取运营方名称epecBelongCompanyId
  getCompanyName(params) {
    return request.fetch(`${urlPrexUser}/company/queryCompanyInfoById`, params);
  }, //
  // 查询是否开通框架协议
  queryEpecPriceIsExist(params) {
    return request.fetch(`${urlPrexProduct}/agreement/queryEpecPriceIsExist`, params);
  },
  // 下载商品协议价格
  downAgreementPrice(params) {
    return request.post(`${urlPrexProduct}/agreement/downAgreementPrice`, params, { responseType: 'blob' });
  },
  // 判断供应商是否维护商品
  isMaintanceProduct(params) {
    return request.post(`${urlPrexProduct}/agreement/queryAgreementExistPriceCount`, params);
  },
  // 根据id获得相应的叶子节点
  getLeafNodes(params) {
    return request.post(`${urlPrexProduct}/category/queryAllLeafCategoryByParentId`, params);
  },
  // 获得物料列表
  getCategoryList(params) {
    return request.fetch(`${urlPrexProduct}/agreement/queryAgreementMaterialList`, params);
  },
  // 提交确认从SCM推送过来的数据
  supplierSubmitConfirmfromSCM(params) {
    return request.fetch(`${urlPrexProduct}/agreement/agreementPriceSupplierSubmitScm`, params);
  },
  // 判断是否开通采购专属商城
  isOpenPurchaseZone() {
    return request.fetch('/user-center/purchaseArea/isOpenBefore');
  },
  // 批量调价
  multiAdjustPrice(params) {
    return request.post('/product/agreement/batchUpdateAgreementPrice', params);
  },
  // 获取全选的协议价商品
  getAllProductPriceList(params) {
    return request.post(`${urlPrexProduct}/agreement/queryAllPrice`, params);
  },
  // 共享资源协议列表
  getProductPriceListShared(params) {
    return request.post(`${urlPrexProduct}/shareAgreement/queryAgreementOfSupplier`, params);
  },

  // 获得共享资源协议维护商品详情
  getSharedAgreementDetail(params) {
    return request.fetch(`${urlPrexProduct}/shareAgreement/agreementInfo`, params);
  },
  // 获得共享资源协议维护商品商品列表
  getSharedAgreementProductList(params) {
    return request.post(`${urlPrexProduct}/shareSku/querySkuSharePage`, params, {
      preventRepeat: false,
    });
  },
  // 获得共享资源协议维护商品停用
  stopSharedAgreement(params) {
    return request.post(`${urlPrexProduct}/shareSku/disable`, params);
  },
  // 获得共享资源协议维护商品启用
  startSharedAgreement(params) {
    return request.post(`${urlPrexProduct}/shareSku/enable`, params);
  },
  // 获得共享资源协议维护商品调价
  sharedAgreementProductAdjustPrice(params) {
    return request.post(`${urlPrexProduct}/shareSku/changePrice`, params);
  },
  // 新增维护商品
  addProductSharedAgreement(params) {
    return request.post(`${urlPrexProduct}/shareSku/batchAdd`, params);
  },
  // 审核维护商品
  auditProductSharedAgreement(params) {
    return request.post(`${urlPrexProduct}/shareSku/batchAudit`, params);
  },
  // 查询维护商品商品列表
  querySharedAgreementProduct(params) {
    return request.post(`${urlPrexProduct}/shareSku/queryUnAddPage`, params);
  },
  // 提交维护商品
  submitSharedAgreement(params) {
    return request.post(`${urlPrexProduct}/shareSku/submit`, params);
  },
  // 提交维护商品
  getAttachmentList(params) {
    return request.post(`${urlPrexProduct}/shareAgreement/queryAgreementAttachmentByPage`, params);
  },
  // 查询物料类别列表分页
  getSharedResourceMdmTypeList(params) {
    return request.post(`${urlPrexProduct}/shareAgreement/queryAgreementCategoryByPage`, params);
  },
  // 获取共享资源协议物料分类 --新接口
  queryAgreementCategoryPage(params) {
    return request.post(`${urlPrexProduct}/shareAgreement/queryAgreementCategoryPage`, params);
  },
  // 获取商品清单
  getSharedResourceProductList(params) {
    return request.post(`${urlPrexProduct}/shareSku/querySkuInfoByPage`, params);
  },
  // 获取类目树
  getAllCategoryTree() {
    return request.fetch(`${urlPrexProduct}/category/queryShareCategoryTree`);
  },
  // 获得共享资源协议维护商品全部调价
  sharedAgreementAllProductAdjustPrice(params) {
    return request.post(`${urlPrexProduct}/shareSku/changePriceByCondition`, params);
  },
  // 资源协议- 维护商品 - 批量删除
  batchRemove(params) {
    return request.post(`${urlPrexProduct}/shareSku/batchRemove`, params);
  },

  // 维护商品-批量删除-勾选全部页下的数据
  removeByCondition(params) {
    return request.post(`${urlPrexProduct}/shareSku/removeByCondition`, params);
  },

  // 获得共享资源协议维护商品全部调价
  sharedAgreementExportProduct(params) {
    return request.post(`${urlPrexProduct}/shareSku/exportSkuShare`, params, {
      responseType: 'blob',
    });
  },
  // 获得共享资源协议维护商品商品清单
  sharedAgreementExportProductList(params) {
    return request.post(`${urlPrexProduct}/shareSku/exportSkuInfo`, params, {
      responseType: 'blob',
    });
  },
  // 获取类目树
  getSharedResourceAllCategoryTree(params) {
    return request.fetch(`${urlPrexProduct}/category/queryShareCategoryTreeByAgreementId`, params);
  },
  // 获取协议类别
  getAgreementType(params) {
    return request.post(`${urlPrexProduct}/agreement/queryAgreementSource`, params);
  },
  // 共享协议新增商品选择全部商品
  addAllProductsList(params) {
    return request.post(`${urlPrexProduct}/shareSku/addByCondition`, params);
  },

  // excel模板下载：
  downTemplate(params) {
    return request.post(`${urlPrexProduct}/shareSku/downTemplate`, params, {
      responseType: 'arraybuffer',
    });
  },
  // 上传结果查看：
  importResult(params) {
    return request.fetch(`${urlPrexProduct}/shareSku/importResult`, params);
  },
  // 导入任务是否正在执行：
  checkLoading(params) {
    return request.fetch(`${urlPrexProduct}/shareSku/checkLoading`, params);
  },
  // 文件表单上传
  importSku(params) {
    return request.post(`${urlPrexProduct}/shareSku/importSku`, params);
  },
  // 资源协议-维护商品-批量停用
  disableBatch(params) {
    return request.post(`${urlPrexProduct}/shareSku/disableBatch`, params);
  },

  // 导入任务是否正在执行：
  checkChangePriceLoading(params) {
    return request.fetch(`${urlPrexProduct}/shareSku/checkChangePriceLoading`, params);
  },
  changePriceTemplate(params) {
    return request.post(`${urlPrexProduct}/shareSku/changePriceTemplate`, params, { responseType: 'arraybuffer' });
  },
  // 文件表单上传
  importChangePrice(params) {
    return request.post(`${urlPrexProduct}/shareSku/importChangePrice`, params);
  },
  // 资源协议-维护商品-勾选全部页下的数据-批量停用
  disableByCondition(params) {
    return request.post(`${urlPrexProduct}/shareSku/disableByCondition`, params);
  },
  // 更新共享协议
  modifyAgreement(params) {
    return request.post('/product/shareAgreement/modifyConpanyAgreement', params);
  },
  // 停用价格联动
  disablePriceLinkage(params) {
    return request.post('/product/shareAgreement/disablePriceLinkage', params);
  },
  // 启用价格联动
  enablePriceLinkage(params) {
    return request.post('/product/shareAgreement/enablePriceLinkage', params);
  },

  // 商品审核列表
  queryAuditSkuPage(params) {
    return request.post('/product/companyCentralizedSku/queryAuditSkuPage', params);
  },
  // 待审核商品数量查询接口
  queryAuditSkuCount(params) {
    return request.fetch('/product/companyCentralizedSku/queryAuditSkuCount', params);
  },
  // 撤回商品-勾选全部页下的数据
  auditByCondition(params) {
    return request.post('/product/companyCentralizedSku/auditByCondition', params);
  },
  // 批量撤回接口
  batchCallBack(params) {
    return request.post('/product/companyCentralizedSku/batchCallBack', params);
  },
  backAgreementDetail(params) {
    return request.post('product/backAgreement/detail', params);
  },
  // 查看导入结果  增加的时候调
  importRecordByIds(params) {
    return request.post('product/backAgreement/importRecordByIds', params);
  },
  // 集采分类
  queryCentralizedCategoryTreeByAgreementId(params) {
    return request.fetch('product/category/queryCentralizedCategoryTreeByAgreementId', params);
  },

  // 低活商品列表
  querySkuByPage(params) {
    return request.post('data-center/shareSku/querySkuByPage', params);
  },
  // 导出低活商品
  exportCompanySkuExcel(params) {
    return request.post(`/data-center/shareSku/exportCompanySkuExcel`, params, { responseType: 'blob' });
  },

  // 导出商品接口
  exportSkuPrice(params) {
    return request.post(`/product/agreement/exportSkuPrice`, params, { responseType: 'blob' });
  },
  // 导入商品调价接口
  importChangePriceAgreement: `${baseUrl}/product/agreement/importChangePrice`,
  // 查看导入结果接口
  importResultAgreement(params) {
    return request.fetch(`/product/agreement/importResult`, params);
  },
  // 批量移除接口
  batchRemoveAgreement(params) {
    return request.post(`/product/agreement/batchRemove`, params);
  },
  // 下载导入模板接口
  downPriceTemplate(params) {
    return request.post(`/product/agreement/downPriceTemplate`, params, { responseType: 'blob' });
  },
};

export default server;
